(function() {
  const callback = () => {
    if(document.querySelector(`.pumper__quantity_label1`)) {
      pumperPriceObserver.disconnect();

      for (let i = 0; i < 3; i++) {
        const pumper_price = window[`pumper_prices_${ i }`];
        const pumper_price_block = document.querySelector(`.pumper__quantity_label${i+1}`);

        if(pumper_price && pumper_price_block) {
          const pumper_price_element = pumper_price_block.querySelector(`#pumper_totalAmount_${i}`);
          const pumper_compare_price_element = pumper_price_block.querySelector(`.pumper_horizontal_compare_price`);
          const pumper_discount_element = pumper_price_block.querySelector(`.pumper_horizontal_subtitle_wrapper .pumper_horizontal_subtitle`);

          pumper_price_element.innerHTML = pumper_price.price;

          if(pumper_price.compare_price) {
            if(pumper_compare_price_element) {
              pumper_compare_price_element.innerHTML = pumper_price.compare_price;
            } else {
              pumper_price_element.insertAdjacentHTML('afterend', `<div class="tier-price__compare pumper_horizontal_compare_price pumper_template_9_prevprice svelte-1ywtgqc" id="pumper_originalAmount_${i}" style="color: #5c5c5c; font-weight: 400; font-style: normal;">${pumper_price.compare_price}</div>`);
            }

            if(pumper_discount_element) {
              pumper_discount_element.removeAttribute('data-tier-subtitle');
              pumper_discount_element.innerHTML = pumper_price.discount;
            } else {
              const pumper_discount_wrapper = pumper_price_block.querySelector(`.pumper_horizontal_title_wrapper`);

              pumper_discount_wrapper.insertAdjacentHTML('afterend', `<div class="pumper_horizontal_subtitle_wrapper svelte-17tcjal"><div class="pumper_horizontal_subtitle svelte-17tcjal" style="color: rgb(255, 255, 255); background-color: rgb(0, 84, 255); border-radius: 6px; font-size: 14px; font-weight: 600; font-style: normal; border: 1px solid rgb(237, 229, 218);">${pumper_price.discount}</div></div>`);
            }
          } else {
            pumper_compare_price_element?.remove();
            pumper_discount_element?.remove();
          }
        }
      }
    }
  };

  const pumperPriceObserver = new MutationObserver(callback);
  const target = document.querySelector('#svelte-bundle-widget');

  pumperPriceObserver.observe(target, {childList: true, subtree: true});
})();
